import { render, staticRenderFns } from "./SdTextarea.vue?vue&type=template&id=eb33ea88&scoped=true"
import script from "./SdTextarea.vue?vue&type=script&lang=js"
export * from "./SdTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb33ea88",
  null
  
)

export default component.exports